// Section 17: priority group 'Pregnant'. Members are listed in sorted id order; the rationing
// phase ranks groups by the policy's order and breaks ties by lowest strength first.
import { definePriorityGroup } from '../../core/registry';
import { peopleSorted } from '../../core/queries';
import type { Config } from '../../config';

export function pregnant(_config: Config) {
  return definePriorityGroup({
    id: 'pregnant',
    label: 'Pregnant',
    section: 'S17',
    members: (ctx) =>
      peopleSorted(ctx.state)
        .filter((p) => p.status.pregnant !== null)
        .map((p) => p.id),
  });
}
